import { render, staticRenderFns } from "./mandala-side-bar-projects.component.vue?vue&type=template&id=4710b376&scoped=true&"
import script from "./mandala-side-bar-projects.component.vue?vue&type=script&lang=ts&"
export * from "./mandala-side-bar-projects.component.vue?vue&type=script&lang=ts&"
import style0 from "./mandala-side-bar-projects.component.vue?vue&type=style&index=0&id=4710b376&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4710b376",
  null
  
)

export default component.exports